import { render, staticRenderFns } from "./ProcessClaimsRIRecoveries.vue?vue&type=template&id=9f1e615a&"
import script from "./ProcessClaimsRIRecoveries.vue?vue&type=script&lang=js&"
export * from "./ProcessClaimsRIRecoveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports